// src/components/transport/apiTransport.js
// Appels vers /api/transport (jeton employé) : l'abonnement des élèves au bus
// et ses réglages (lot 3a) ; les zones de trajet et les dérogations de prix
// (lot 3a bis). Les refus du serveur s'affichent tels qu'il les écrit.

import { getAuthHeaders } from '../../services/api';

const RACINE = '/api/transport';

async function appeler(chemin, { methode = 'GET', corps } = {}) {
  let reponse;
  try {
    reponse = await fetch(`${RACINE}${chemin}`, {
      method: methode,
      headers: getAuthHeaders(),
      body: corps !== undefined ? JSON.stringify(corps) : undefined
    });
  } catch {
    throw new Error('Connexion au serveur impossible. Vérifiez la connexion et réessayez.');
  }
  let donnees = null;
  try { donnees = await reponse.json(); } catch { donnees = null; }
  if (!reponse.ok) {
    const erreur = new Error(donnees?.message || donnees?.error || 'Une erreur est survenue.');
    erreur.code = donnees?.code;
    erreur.statut = reponse.status;
    throw erreur;
  }
  return donnees?.data;
}

export const transport = {
  reglages: () => appeler('/reglages'),
  enregistrerReglages: (reglages) => appeler('/reglages', { methode: 'PUT', corps: reglages }),
  eleve: (eleveId) => appeler(`/eleves/${encodeURIComponent(eleveId)}`),
  abonner: (eleveId, choix) => appeler(`/eleves/${encodeURIComponent(eleveId)}`, { methode: 'PUT', corps: choix }),
  demanderDerogation: (eleveId, demande) => appeler(`/eleves/${encodeURIComponent(eleveId)}/derogations`, { methode: 'POST', corps: demande }),
  zones: () => appeler('/zones'),
  creerZone: (zone) => appeler('/zones', { methode: 'POST', corps: zone }),
  modifierZone: (zoneId, zone) => appeler(`/zones/${encodeURIComponent(zoneId)}`, { methode: 'PUT', corps: zone }),
  changerTarifZone: (zoneId, changement) => appeler(`/zones/${encodeURIComponent(zoneId)}/tarif`, { methode: 'PUT', corps: changement }),
  activerZone: (zoneId, actif) => appeler(`/zones/${encodeURIComponent(zoneId)}/actif`, { methode: 'PUT', corps: { actif } })
};

export const fcfa = (montant) => `${new Intl.NumberFormat('fr-FR').format(Math.round(Number(montant || 0)))} FCFA`;

export const SENS = {
  aller_retour: 'Aller et retour',
  aller: 'Aller seul (matin)',
  retour: 'Retour seul (soir)'
};

/** La mensualité, calculée comme le serveur (prixTransport.montantMensuel). */
export function montantMensuel(tarif, sens, pourcentage = 50) {
  const t = Math.round(Number(tarif) || 0);
  if (t <= 0) return 0;
  return sens === 'aller' || sens === 'retour' ? Math.max(1, Math.round((t * pourcentage) / 100)) : t;
}

/** Le prix d'un ticket, calculé comme le serveur (prixTransport.prixTicket). */
export function prixTicket(tarif, type, reglages = {}) {
  const t = Math.round(Number(tarif) || 0);
  if (t <= 0) return 0;
  const journee = Math.max(1, Math.round(t / (Number(reglages.ticket_diviseur) || 20)));
  return type === 'demi_journee' ? Math.max(1, Math.round((journee * (Number(reglages.pourcentage_un_sens) || 50)) / 100)) : journee;
}
